// extracted by mini-css-extract-plugin
export default {"container":"PrivateRoutes_container__e52-i","loader":"PrivateRoutes_loader__hpjO4"};